//@ts-ignore
import { onlyNumeric } from '@origin-digital/normalize';
import { Accordion, Box, Text } from '@origin-digital/style-guide';
import { Field, FieldArray, FieldArrayRenderProps } from 'formik';
import React from 'react';

import analytics from '../../../../../../analytics';
import { currencyTransform } from '../../../../../../utils/transforms';
import FormRow from '../../../../../../components/Form/Fields/FormRow';
import TextField from '../../../../../../components/Form/Fields/TextField';
import RadioGroup from '../../../../../../components/Form/Fields/RadioGroup';

import { StepTwoProps } from './StepTwo.types';
import Checkbox from '../../../../../../components/Form/Fields/Checkbox';

export default class StepTwo extends React.Component<StepTwoProps> {
  componentDidMount() {
    analytics.pageLoad('step2');
  }

  render(): JSX.Element {
    const { metaData } = this.props;

    return (
      <React.Fragment>
        <FormRow
          content={metaData.form.content.yourDetails}
          byline={metaData.form.content.yourDetails.byline}
          rowMarginBottom={6}
        >
          <Field
            name={metaData.form.fields.firstName.name}
            component={TextField}
            label={metaData.form.fields.firstName.label}
            maxLength={150}
          />
          <Field
            name={metaData.form.fields.lastName.name}
            component={TextField}
            label={metaData.form.fields.lastName.label}
            maxLength={150}
          />
          <Field
            name={metaData.form.fields.email.name}
            component={TextField}
            label={metaData.form.fields.email.label}
            maxLength={150}
          />
          <Field
            name={metaData.form.fields.phone.name}
            component={TextField}
            helpText={metaData.form.fields.phone.helpText}
            label={metaData.form.fields.phone.label}
            transform={onlyNumeric}
            maxLength={10}
          />
        </FormRow>

        <Box marginBottom={10}>
          <Accordion
            label={metaData.form.content.optionalAccordion.label}
            onToggle={e => {
              analytics.accordionClick('speed-up', metaData.form.content.optionalAccordion.label, e.isOpen);
            }}
          >
            <Field
              name={metaData.form.fields.averageQuarterlyBillCost.name}
              component={TextField}
              label={metaData.form.fields.averageQuarterlyBillCost.label}
              transform={currencyTransform}
            />

            <FormRow content={metaData.form.content.usagePercentDuringDay} rowMarginBottom={6}>
              <FieldArray
                name={metaData.form.fields.usagePercentDuringDay.name}
                render={(arrayHelpers: FieldArrayRenderProps) => (
                  <RadioGroup
                    name={metaData.form.fields.usagePercentDuringDay.name}
                    options={metaData.form.fields.usagePercentDuringDay.options}
                    arrayHelpers={arrayHelpers}
                    maxWidth={300}
                  />
                )}
              />
            </FormRow>

            <FormRow
              content={metaData.form.content.propertyStorey}
              byline={metaData.form.content.propertyStorey.byline}
              rowMarginBottom={6}
            >
              <FieldArray
                name={metaData.form.fields.propertyStorey.name}
                render={(arrayHelpers: FieldArrayRenderProps) => (
                  <RadioGroup
                    name={metaData.form.fields.propertyStorey.name}
                    options={metaData.form.fields.propertyStorey.options}
                    arrayHelpers={arrayHelpers}
                    maxWidth={300}
                  />
                )}
              />
            </FormRow>

            <FormRow
              content={metaData.form.content.roofPitch}
              byline={metaData.form.content.roofPitch.byline}
              rowMarginBottom={6}
            >
              <FieldArray
                name={metaData.form.fields.roofPitch.name}
                render={(arrayHelpers: FieldArrayRenderProps) => (
                  <RadioGroup
                    name={metaData.form.fields.roofPitch.name}
                    options={metaData.form.fields.roofPitch.options}
                    arrayHelpers={arrayHelpers}
                    maxWidth={300}
                  />
                )}
              />
            </FormRow>

            <FormRow
              content={metaData.form.content.powerConnectionPhaseType}
              byline={metaData.form.content.powerConnectionPhaseType.byline}
              rowMarginBottom={6}
            >
              <FieldArray
                name={metaData.form.fields.powerConnectionPhaseType.name}
                render={(arrayHelpers: FieldArrayRenderProps) => (
                  <RadioGroup
                    name={metaData.form.fields.powerConnectionPhaseType.name}
                    options={metaData.form.fields.powerConnectionPhaseType.options}
                    arrayHelpers={arrayHelpers}
                  />
                )}
              />
            </FormRow>
          </Accordion>
        </Box>
        <FormRow content={metaData.form.content.allowMarketingByline} rowMarginBottom={10}>
          <Box marginTop={2} marginBottom={4}>
            <Text size={'sm'}>{metaData.form.content.allowMarketingByline}</Text>
          </Box>
          <Field
            name={metaData.form.fields.allowMarketingCommunications.name}
            id={metaData.form.fields.allowMarketingCommunications.name}
            component={Checkbox}
            label={metaData.form.fields.allowMarketingCommunications.label}
          />
        </FormRow>
      </React.Fragment>
    );
  }
}
